import {
  IonButton,
  IonItem,
  IonList,
  IonPopover,
  IonRadio,
  IonRadioGroup,
  IonRefresher,
  IonRefresherContent,
  IonSkeletonText,
  useIonToast,
  IonModal,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonIcon,
  IonContent,
  IonAccordionGroup,
  IonAccordion,
  IonFooter,
  IonLabel,
  IonSearchbar,
  IonInput,
  IonGrid,
  IonCol,
  IonRow,
  IonBackButton
} from "@ionic/react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { CardComponent } from "../components/Cards/StoreCard";
import MyPortal from "../components/MyPortal";
import dayjs from "dayjs";
import { useParams, useHistory } from "react-router-dom";
import SortFunctions from "../components/SortFunctions";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import {
  funnel as funnelOutline,
  close as closeOutline,
  funnelSharp,
  search as searchOutline,
  arrowBack
} from 'ionicons/icons';

const fields = [
  { label: "TS", dataIndex: "today_amt" },
  { label: "YS", dataIndex: "yesterday_amt" },
  { label: "WTD", dataIndex: "this_week_amt" },
  { label: "MTD", dataIndex: "this_month_amt" },
  { label: "", dataIndex: "ts_last_year_amt" },
  { label: "", dataIndex: "ys_last_year_amt" },
  { label: "", dataIndex: "ws_last_year_amt" },
  { label: "", dataIndex: "ms_last_year_amt" },
  { label: "TSGR%", dataIndex: "today_growth_pct" },
  { label: "YSGR%", dataIndex: "yesterday_growth_pct" },
  { label: "WTDGR%", dataIndex: "week_growth_pct" },
  { label: "MTDGR%", dataIndex: "month_growth_pct" },
];

export default function StoreSummary() {
  const { regionName } = useParams();
  const history = useHistory();
  const suBase = history.location.pathname.startsWith("/legacy/") ? "/legacy" : "";
  const authReducer = useSelector((state) => state.authReducer);
  const [details, setDetails] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [present] = useIonToast();

  const [sortState, setSortState] = React.useState({ key: null, direction: null });
  const { handleAscSort, handleDesSort } = SortFunctions({ details, setSortState, setDetails });

  const [masterStoreTypes, setMasterStoreTypes] = React.useState(['LTL', 'PTL', 'NEW_STORE']);
  const [storeTypeFilter, setStoreTypeFilter] = React.useState(null);

  // Initialize storeType from URL query param so the header shows the selected type immediately
  React.useEffect(() => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const s = urlParams.get('storeType');
      if (s) {
        setStoreTypeFilter(s);
        setPendingStoreType(s);
      }
    } catch (err) {
      // ignore
    }
  }, []);

  const [isSortPopoverOpen, setIsSortPopoverOpen] = React.useState(false);
  const [isStoreTypePopoverOpen, setIsStoreTypePopoverOpen] = React.useState(false);

  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [isMobileFilterDrawerOpen, setIsMobileFilterDrawerOpen] = React.useState(false);
  const filtersApplied = storeTypeFilter !== null || sortState.key !== null;
  const [selectedSortOption, setSelectedSortOption] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);

  // Pending (staged) filter/sort state for mobile drawer
  const [pendingStoreType, setPendingStoreType] = useState(storeTypeFilter ?? "all");
  const [pendingSelectedSortOption, setPendingSelectedSortOption] = useState(selectedSortOption);
  const [pendingSortState, setPendingSortState] = useState(sortState);

  function openMobileFilterDrawer() {
    setPendingStoreType(storeTypeFilter ?? "all");
    setPendingSelectedSortOption(selectedSortOption);
    setPendingSortState(sortState);
    setIsMobileFilterDrawerOpen(true);
  }

  // Helper to keep the `storeType` query param in sync with UI selections
  function updateUrlStoreType(value) {
    try {
      const url = new URL(window.location.href);
      if (value === null || value === undefined || value === 'all') {
        url.searchParams.delete('storeType');
      } else {
        url.searchParams.set('storeType', value);
      }
      window.history.replaceState({}, '', url.toString());
    } catch (err) {
      console.warn('Failed to update URL storeType param', err);
    }
  }

  function resetPendingToApplied() {
    setPendingStoreType(storeTypeFilter ?? "all");
    setPendingSelectedSortOption(selectedSortOption);
    setPendingSortState(sortState);
  }

  function handleDSort() {

    window.location.reload(true);
  }

  const getData = async (refreshEvent, options = {}) => {
    setLoading(true);
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const localStoreType = urlParams.get("storeType");

      const appliedStoreType = options.hasOwnProperty('storeType') ? options.storeType : localStoreType || storeTypeFilter;
      const appliedSortState = options.hasOwnProperty('sortState') ? options.sortState : sortState;
      const appliedSearchText = options.hasOwnProperty('searchText') ? options.searchText : searchText;

      const params = {
        summary: "store",
        store_type: appliedStoreType || undefined,
        region: regionName == 'All STORES' ? undefined : regionName
      };

      const res = await axios.get("/style_union/get_sales_data", { params });

      // localStorage.removeItem("store_type");
      const formatToLakh = (value) => (value / 100000).toFixed(2);

      const mapped = res.data.data.map((item) => ({
        ...item,
        today_amt_number: item.today_amt || 0,
        yesterday_amt_number: item.yesterday_amt || 0,
        this_week_amt_number: item.this_week_amt || 0,
        this_month_amt_number: item.this_month_amt || 0,
        today_amt: item.today_amt,
        yesterday_amt: item.yesterday_amt,
        this_week_amt: item.this_week_amt,
        this_month_amt: item.this_month_amt,
        store_count: item.store_count ?? item.total_stores ?? item.count ?? 0,
        ts_last_year_amt: `${formatToLakh(item.ts_last_year_amt || 0)} `,
        ys_last_year_amt: `${formatToLakh(item.ys_last_year_amt || 0)} `,
        ws_last_year_amt: `${formatToLakh(item.ws_last_year_amt || 0)} `,
        ms_last_year_amt: `${formatToLakh(item.ms_last_year_amt || 0)} `,
        wtd_gr_percent: item.week_growth_pct || 0,
        mtd_gr_percent: item.month_growth_pct || 0,
      }));

      let finalDetails = mapped;

      if (appliedSortState && appliedSortState.key && appliedSortState.direction) {
        finalDetails = [...finalDetails].sort((a, b) => {
          const aVal = a[appliedSortState.key] ?? 0;
          const bVal = b[appliedSortState.key] ?? 0;
          return appliedSortState.direction === "asc" ? aVal - bVal : bVal - aVal;
        });
      }

      const filteredDetails = finalDetails.filter((item) =>
        item.store_name?.toLowerCase().includes((appliedSearchText || "").toLowerCase())
      );

      // keep Style Union item first if present
      setDetails([finalDetails?.find((item) => item?.store_name === "Style Union"), ...filteredDetails?.filter((item) => item?.store_name !== "Style Union")]);

      // master store types are hardcoded for UI as LTL / PTL / NEWSTORE; do not override them from API
    } catch (err) {
      console.error("Error fetching sales data:", err);
      await present({
        message: err?.response?.data?.message || "Error Occurred",
        duration: 2000,
        color: "danger",
      });
    }
    setLoading(false);
    refreshEvent?.detail?.complete();
  };

  useEffect(() => {
    getData();
  }, [storeTypeFilter, searchText, regionName]);

  return (
    <div style={{
      display: "inline-flex",
      justifyContent: "space-around",
      width: "100%",
      flexWrap: "wrap",
      position: "relative",
      paddingBottom: "50px",
    }}>
      <IonRefresher slot="fixed" onIonRefresh={getData}>
        <IonRefresherContent></IonRefresherContent>
      </IonRefresher>

      {loading && !details?.length &&
        Array.from({ length: 10 }).map((_, i) => (
          <IonSkeletonText
            key={i}
            animated={true}
            style={{ height: "150px" }}
          />
        ))}

      {/* TOPBAR */}
      <MyPortal id="navbar-portal-div">
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          padding:  "0 2rem",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: "1rem", flex: isMobile ? "1 1 auto" : undefined, minWidth: 0 }}>
            {!isMobile && (
              <IonButtons slot="start">
                <IonBackButton
                  defaultHref={`${suBase}/sales/styleunion`}
                  text={"Back"}
                  icon={arrowBack}
                />
              </IonButtons>
            )}
            <div style={{ fontWeight: 500, display: "grid", fontSize: "1.0rem", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {decodeURIComponent(regionName)}
              <span style={{ fontSize: "0.8rem", marginTop: "0.2rem" }}>


                {details?.[1]?.updated_at && dayjs(details?.[1]?.updated_at).fromNow()}
              </span>
            </div>
          </div>

          <div style={{ flex: "0 0 auto" }}>
            {isMobile ? (
              <div style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}>
                {/* Search button */}
                <IonButton
                  fill="clear"
                  size="small"
                  onClick={() => setIsSearchModalOpen(true)}
                >
                  <IonIcon icon={searchOutline} />
                </IonButton>

                {/* Filter button */}
                <IonButton
                  fill="clear"
                  size="small"
                  onClick={openMobileFilterDrawer}
                >
                  <IonIcon icon={filtersApplied ? funnelSharp : funnelOutline} />
                </IonButton>

                {/* Back button (mobile) */}
                <IonButton
                  fill="clear"
                  size="small"
                  onClick={() => history.goBack()}
                >
                  <IonIcon icon={arrowBack} />
                </IonButton>
              </div>
            ) : (
              <div style={{ display: "inline-flex" }}>
                <div style={{
                  height: '20px',
                  marginRight: '10px'
                }}>
                  <IonSearchbar
                    value={searchText}
                    onIonInput={(e) => {
                      const value = e.target.value;
                      setSearchText(value);
                    }}
                    placeholder="Search store..."
                    debounce={300}
                  />
                </div>

                <div>
                  <IonButton
                    size="default"
                    color="white"
                    id="popover-su-button"
                    onClick={() => setIsSortPopoverOpen(!isSortPopoverOpen)}
                  >
                    Sort By
                  </IonButton>
                  <IonButton
                    size="default"
                    color="white"
                    id="popover-storetype-button"
                    onClick={() => setIsStoreTypePopoverOpen(!isStoreTypePopoverOpen)}
                  >
                    STORE TYPE: {storeTypeFilter ?? "All"}
                  </IonButton>
                </div>
              </div>
            )}
          </div>
        </div>
      </MyPortal>

      {/* Cards */}
      <div className="cards-container" style={{
        display: "flex",
        flexWrap: "wrap",
        gap: isMobile ? "0.5rem" : "1rem",
        padding: isMobile ? "0.5rem" : "1rem",
        width: "100%",
        justifyContent: "center"
      }}>
        {(searchText
          ? details.filter(item => item.store_name !== "Style Union")
          : details
        ).map((item, index) => (
          <div
            key={index}
            style={{
              flexBasis: isMobile ? "100%" : "calc(50% - 1rem)",
              maxWidth: isMobile ? "100%" : "400px",
              minWidth: isMobile ? "auto" : "300px"
            }}
          >
            <CardComponent
              data={item}
              fields={fields}
              fieldsInOneRow={4}
              showStoreCountRight={item.store_name === "Style Union"}
            />
          </div>
        ))}
      </div>

      {/* Popovers for Sorting and Filtering */}
      <IonPopover
        isOpen={isSortPopoverOpen}
        trigger="popover-su-button"
        keepContentsMounted
        dismissOnSelect={false}
        side="bottom"
        size="auto"
        className="wide-popover"
      >
        <IonContent className="ion-padding">
          <IonAccordionGroup expand="first">
            {/* Default */}
            <IonItem
              button
              onClick={() => {
                setSelectedSortOption("default");
                handleDSort("default");
              }}
            >
              <IonLabel><b>Default</b></IonLabel>
            </IonItem>

            {/* TS */}
            <IonAccordion value="ts">
              <IonItem slot="header">
                <IonLabel>TS</IonLabel>
              </IonItem>
              <div className="ion-padding" slot="content">
                <IonRadioGroup
                  value={selectedSortOption}
                  onIonChange={(e) => {
                    const value = e.detail.value;
                    setSelectedSortOption(value);
                    if (value === "ts_asc") handleAscSort("today_amt");
                    else if (value === "ts_desc") handleDesSort("today_amt");
                    setIsSortPopoverOpen(false);
                  }}
                >
                  <IonItem>
                    <IonLabel>Low to High</IonLabel>
                    <IonRadio slot="end" value="ts_asc" />
                  </IonItem>
                  <IonItem>
                    <IonLabel>High to Low</IonLabel>
                    <IonRadio slot="end" value="ts_desc" />
                  </IonItem>
                </IonRadioGroup>
              </div>
            </IonAccordion>

            {/* YS */}
            <IonAccordion value="ys">
              <IonItem slot="header">
                <IonLabel>YS</IonLabel>
              </IonItem>
              <div className="ion-padding" slot="content">
                <IonRadioGroup
                  value={selectedSortOption}
                  onIonChange={(e) => {
                    const value = e.detail.value;
                    setSelectedSortOption(value);
                    if (value === "ys_asc") handleAscSort("yesterday_amt");
                    else if (value === "ys_desc") handleDesSort("yesterday_amt");
                    setIsSortPopoverOpen(false);
                  }}
                >
                  <IonItem>
                    <IonLabel>Low to High</IonLabel>
                    <IonRadio slot="end" value="ys_asc" />
                  </IonItem>
                  <IonItem>
                    <IonLabel>High to Low</IonLabel>
                    <IonRadio slot="end" value="ys_desc" />
                  </IonItem>
                </IonRadioGroup>
              </div>
            </IonAccordion>

            {/* WTD */}
            <IonAccordion value="wtds">
              <IonItem slot="header">
                <IonLabel>WTD</IonLabel>
              </IonItem>
              <div className="ion-padding" slot="content">
                <IonRadioGroup
                  value={selectedSortOption}
                  onIonChange={(e) => {
                    const value = e.detail.value;
                    setSelectedSortOption(value);
                    if (value === "wtds_asc") handleAscSort("this_week_amt");
                    else if (value === "wtds_desc") handleDesSort("this_week_amt");
                    setIsSortPopoverOpen(false);
                  }}
                >
                  <IonItem>
                    <IonLabel>Low to High</IonLabel>
                    <IonRadio slot="end" value="wtds_asc" />
                  </IonItem>
                  <IonItem>
                    <IonLabel>High to Low</IonLabel>
                    <IonRadio slot="end" value="wtds_desc" />
                  </IonItem>
                </IonRadioGroup>
              </div>
            </IonAccordion>

            {/* MTD */}
            <IonAccordion value="mtds">
              <IonItem slot="header">
                <IonLabel>MTD</IonLabel>
              </IonItem>
              <div className="ion-padding" slot="content">
                <IonRadioGroup
                  value={selectedSortOption}
                  onIonChange={(e) => {
                    
                    const value = e.detail.value;
                    setSelectedSortOption(value);
                    if (value === "mtds_asc") handleAscSort("this_month_amt");
                    else if (value === "mtds_desc") handleDesSort("this_month_amt");
                    setIsSortPopoverOpen(false);
                  }}
                >
                  <IonItem>
                    <IonLabel>Low to High</IonLabel>
                    <IonRadio slot="end" value="mtds_asc" />
                  </IonItem>
                  <IonItem>
                    <IonLabel>High to Low</IonLabel>
                    <IonRadio slot="end" value="mtds_desc" />
                  </IonItem>
                </IonRadioGroup>
              </div>
            </IonAccordion>

            {/* WTD GROWTH */}
            <IonAccordion value="wtds_growth">
              <IonItem slot="header">
                <IonLabel>WTD Growth</IonLabel>
              </IonItem>
              <div className="ion-padding" slot="content">
                <IonRadioGroup
                  value={selectedSortOption}
                  onIonChange={(e) => {
                    const value = e.detail.value;
                    setSelectedSortOption(value);
                    if (value === "wtdsgr_asc") handleAscSort("wtd_gr_percent");
                    else if (value === "wtdsgr_desc") handleDesSort("wtd_gr_percent");
                  }}
                >
                  <IonItem>
                    <IonLabel>Low to High</IonLabel>
                    <IonRadio slot="end" value="wtdsgr_asc" />
                  </IonItem>
                  <IonItem>
                    <IonLabel>High to Low</IonLabel>
                    <IonRadio slot="end" value="wtdsgr_desc" />
                  </IonItem>
                </IonRadioGroup>
              </div>
            </IonAccordion>

            {/* MTDS GROWTH */}
            <IonAccordion value="mtd_growth">
              <IonItem slot="header">
                <IonLabel>MTD Growth</IonLabel>
              </IonItem>
              <div className="ion-padding" slot="content">
                <IonRadioGroup
                  value={selectedSortOption}
                  onIonChange={(e) => {
                    const value = e.detail.value;
                    setSelectedSortOption(value);
                    if (value === "mtdsgr_asc") handleAscSort("mtd_gr_percent");
                    else if (value === "mtdsgr_desc") handleDesSort("mtd_gr_percent");
                    setIsSortPopoverOpen(false);
                  }}
                >
                  <IonItem>
                    <IonLabel>Low to High</IonLabel>
                    <IonRadio slot="end" value="mtdsgr_asc" />
                  </IonItem>
                  <IonItem>
                    <IonLabel>High to Low</IonLabel>
                    <IonRadio slot="end" value="mtdsgr_desc" />
                  </IonItem>
                </IonRadioGroup>
              </div>
            </IonAccordion>

          </IonAccordionGroup>




        </IonContent>
      </IonPopover>

      <IonPopover
        isOpen={isStoreTypePopoverOpen}
        trigger="popover-storetype-button"
        keepContentsMounted
        dismissOnSelect
        side="bottom"
        size="auto"
      >
        <IonList>
          <IonRadioGroup
            value={storeTypeFilter ?? "all"}
            onIonChange={(e) => {
              const val = e.detail.value;
              const applied = val === "all" ? null : val;
              setStoreTypeFilter(applied);
              updateUrlStoreType(applied);
              setIsStoreTypePopoverOpen(false);
            }}
          >
            <IonItem>
              <IonLabel>All Store Types</IonLabel>
              <IonRadio slot="end" value="all" />
            </IonItem>
            {/* Hardcoded list for UI selection */}
            <IonItem>
              <IonLabel>LTL</IonLabel>
              <IonRadio slot="end" value="LTL" />
            </IonItem>
            <IonItem>
              <IonLabel>PTL</IonLabel>
              <IonRadio slot="end" value="PTL" />
            </IonItem>
            <IonItem>
              <IonLabel>NEW_STORE</IonLabel>
              <IonRadio slot="end" value="NEW_STORE" />
            </IonItem>
          </IonRadioGroup>
        </IonList>
      </IonPopover>

      {/* Mobile Search Modal */}
      <IonModal
        isOpen={isSearchModalOpen}
        onDidDismiss={() => setIsSearchModalOpen(false)}
      >
        <IonHeader>
          <IonToolbar>
            <IonTitle>Search Store</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => setIsSearchModalOpen(false)}>
                <IonIcon icon={closeOutline} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding">
          <IonItem>
            <IonIcon icon={searchOutline} slot="start" />
            <IonInput
              type="text"
              value={searchText}
              placeholder="Search store name..."
              onIonInput={(e) => {
                const value = e.target.value;
                setSearchText(value);
              }}
              clearInput
            />
          </IonItem>

          <IonGrid>
            <IonRow>
              <IonCol size="6">
                <IonButton
                  expand="block"
                  onClick={() => {
                    // Keep searchText in state so getData will pick it up via dependency
                    setIsSearchModalOpen(false);
                  }}
                >
                  Search
                </IonButton>
              </IonCol>

              <IonCol size="6">
                <IonButton
                  expand="block"
                  fill="outline"
                  color="medium"
                  onClick={() => {
                    setSearchText(""); // Clear input
                    setIsSearchModalOpen(false);
                  }}
                >
                  Clear
                </IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>
      </IonModal>

      {/* Mobile Filter Drawer */}
      <IonModal
        isOpen={isMobileFilterDrawerOpen}
        onDidDismiss={() => {
          setIsMobileFilterDrawerOpen(false);
          resetPendingToApplied();
        }}
        className="mobile-filter-modal"
      >
        <IonHeader>
          <IonToolbar>
            <IonTitle>Filters</IonTitle>
            {/* close icon removed from header; use footer Apply/Clear to close */}
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding">
          <IonAccordionGroup expand="first">
            <IonAccordion value="storetype">
              <IonItem slot="header">
                <IonLabel>Store Type</IonLabel>
              </IonItem>
              <div className="ion-padding" slot="content">
                <IonRadioGroup
                  value={pendingStoreType ?? "all"}
                  onIonChange={(e) => setPendingStoreType(e.detail.value)}
                >
                  <IonItem>
                    <IonLabel>All Store Types</IonLabel>
                    <IonRadio slot="end" value="all" />
                  </IonItem>
                  {masterStoreTypes.map((type) => (
                    <IonItem key={type}>
                      <IonLabel>{type}</IonLabel>
                      <IonRadio slot="end" value={type} />
                    </IonItem>
                  ))}
                </IonRadioGroup>
              </div>
            </IonAccordion>

            <IonAccordion value="sort">
              <IonItem slot="header"><b>Sort By</b></IonItem>
              <div className="ion-padding" slot="content">
                <IonRadioGroup>
                  <IonAccordionGroup expand="inset">
                    {/* Default Sort */}
                    <IonItem button onClick={() => { setPendingSelectedSortOption("default"); setPendingSortState({ key: null, direction: null }); }}>
                      Default
                    </IonItem>

                    {/* TS Sort */}
                    <IonAccordion value="ts">
                      <IonItem slot="header">
                        <IonLabel>TS</IonLabel>
                      </IonItem>

                      <div className="ion-padding" slot="content">
                        <IonRadioGroup
                          value={pendingSelectedSortOption}
                          onIonChange={(e) => {
                            const value = e.detail.value;
                            setPendingSelectedSortOption(value);
                            if (value === "ts_asc") setPendingSortState({ key: 'today_amt', direction: 'asc' });
                            else if (value === "ts_desc") setPendingSortState({ key: 'today_amt', direction: 'desc' });
                          }}
                        >
                          <IonItem>
                            <IonLabel>Low to High</IonLabel>
                            <IonRadio slot="end" value="ts_asc" />
                          </IonItem>
                          <IonItem>
                            <IonLabel>High to Low</IonLabel>
                            <IonRadio slot="end" value="ts_desc" />
                          </IonItem>
                        </IonRadioGroup>
                      </div>
                    </IonAccordion>

                    {/* YS Sort */}
                    <IonAccordion value="ys">
                      <IonItem slot="header">
                        <IonLabel>YS</IonLabel>
                      </IonItem>

                      <div className="ion-padding" slot="content">
                        <IonRadioGroup
                          value={pendingSelectedSortOption}
                          onIonChange={(e) => {
                            const value = e.detail.value;
                            setPendingSelectedSortOption(value);
                            if (value === "ys_asc") setPendingSortState({ key: 'yesterday_amt', direction: 'asc' });
                            else if (value === "ys_desc") setPendingSortState({ key: 'yesterday_amt', direction: 'desc' });
                          }}
                        >
                          <IonItem>
                            <IonLabel>Low to High</IonLabel>
                            <IonRadio slot="end" value="ys_asc" />
                          </IonItem>
                          <IonItem>
                            <IonLabel>High to Low</IonLabel>
                            <IonRadio slot="end" value="ys_desc" />
                          </IonItem>
                        </IonRadioGroup>
                      </div>
                    </IonAccordion>

                    {/* WS Sort */}
                    <IonAccordion value="ws">
                      <IonItem slot="header">
                        <IonLabel>WTDS</IonLabel>
                      </IonItem>

                      <div className="ion-padding" slot="content">
                        <IonRadioGroup
                          value={pendingSelectedSortOption}
                          onIonChange={(e) => {
                            const value = e.detail.value;
                            setPendingSelectedSortOption(value);
                            if (value === "wtds_asc") setPendingSortState({ key: 'this_week_amt', direction: 'asc' });
                            else if (value === "wtds_desc") setPendingSortState({ key: 'this_week_amt', direction: 'desc' });
                          }}
                        >
                          <IonItem>
                            <IonLabel>Low to High</IonLabel>
                            <IonRadio slot="end" value="wtds_asc" />
                          </IonItem>
                          <IonItem>
                            <IonLabel>High to Low</IonLabel>
                            <IonRadio slot="end" value="wtds_desc" />
                          </IonItem>
                        </IonRadioGroup>
                      </div>
                    </IonAccordion>

                    {/* MS Sort */}
                    <IonAccordion value="ms">
                      <IonItem slot="header">
                        <IonLabel>MTDS</IonLabel>
                      </IonItem>

                      <div className="ion-padding" slot="content">
                        <IonRadioGroup
                          value={pendingSelectedSortOption}
                          onIonChange={(e) => {
                            const value = e.detail.value;
                            setPendingSelectedSortOption(value);
                            if (value === "mtds_asc") setPendingSortState({ key: 'this_month_amt', direction: 'asc' });
                            else if (value === "mtds_desc") setPendingSortState({ key: 'this_month_amt', direction: 'desc' });
                          }}
                        >
                          <IonItem>
                            <IonLabel>Low to High</IonLabel>
                            <IonRadio slot="end" value="mtds_asc" />
                          </IonItem>
                          <IonItem>
                            <IonLabel>High to Low</IonLabel>
                            <IonRadio slot="end" value="mtds_desc" />
                          </IonItem>
                        </IonRadioGroup>
                      </div>
                    </IonAccordion>
                    {/* WTD growth Sort */}
                    <IonAccordion value="wtd growth">
                      <IonItem slot="header">
                        <IonLabel>WTD Growth</IonLabel>
                      </IonItem>

                      <div className="ion-padding" slot="content">
                        <IonRadioGroup
                          value={pendingSelectedSortOption}
                          onIonChange={(e) => {
                            const value = e.detail.value;
                            setPendingSelectedSortOption(value);
                            if (value === "wtdsgr_asc") setPendingSortState({ key: 'wtd_gr_percent', direction: 'asc' });
                            else if (value === "wtdsgr_desc") setPendingSortState({ key: 'wtd_gr_percent', direction: 'desc' });
                          }}
                        >
                          <IonItem>
                            <IonLabel>Low to High</IonLabel>
                            <IonRadio slot="end" value="wtdsgr_asc" />
                          </IonItem>
                          <IonItem>
                            <IonLabel>High to Low</IonLabel>
                            <IonRadio slot="end" value="wtdsgr_desc" />
                          </IonItem>
                        </IonRadioGroup>
                      </div>
                    </IonAccordion>
                    {/* MTD growth Sort */}
                    <IonAccordion value="mtds growth">
                      <IonItem slot="header">
                        <IonLabel>MTD Growth</IonLabel>
                      </IonItem>

                      <div className="ion-padding" slot="content">
                        <IonRadioGroup
                          value={pendingSelectedSortOption}
                          onIonChange={(e) => {
                            const value = e.detail.value;
                            setPendingSelectedSortOption(value);
                            if (value === "mtdsgr_asc") setPendingSortState({ key: 'mtd_gr_percent', direction: 'asc' });
                            else if (value === "mtdsgr_desc") setPendingSortState({ key: 'mtd_gr_percent', direction: 'desc' });
                          }}
                        >
                          <IonItem>
                            <IonLabel>Low to High</IonLabel>
                            <IonRadio slot="end" value="mtdsgr_asc" />
                          </IonItem>
                          <IonItem>
                            <IonLabel>High to Low</IonLabel>
                            <IonRadio slot="end" value="mtdsgr_desc" />
                          </IonItem>
                        </IonRadioGroup>
                      </div>
                    </IonAccordion>
                  </IonAccordionGroup>
                </IonRadioGroup>
              </div>
            </IonAccordion>


          </IonAccordionGroup>


        </IonContent>
        <IonFooter>
          <IonToolbar>
            <div style={{ display: 'flex', gap: '0.5rem', padding: '0.5rem', width: '100%' }}>
              <div style={{ flex: 1 }}>
                <IonButton
                  expand="block"
                  fill="outline"
                  color="medium"
                  onClick={async () => {
                    // Reset pending values
                    setPendingStoreType("all");
                    setPendingSelectedSortOption(null);
                    setPendingSortState({ key: null, direction: null });
                    // Also clear applied filters/sort
                    setStoreTypeFilter(null);
                    setSelectedSortOption(null);
                    setSortState({ key: null, direction: null });
                    // Close drawer and refresh list using cleared overrides
                    setIsMobileFilterDrawerOpen(false);
                    updateUrlStoreType(null);
                    await getData(null, { storeType: null, sortState: { key: null, direction: null } });
                  }}
                >
                  Clear
                </IonButton>
              </div>

              <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                <div style={{ width: '160px' }}>
                  <IonButton
                    expand="block"
                    onClick={async () => {
                      // Commit pending filters to applied state
                      const appliedStore = pendingStoreType === "all" ? null : pendingStoreType;
                      setStoreTypeFilter(appliedStore);
                      setSelectedSortOption(pendingSelectedSortOption);
                      setSortState(pendingSortState);
                      setIsMobileFilterDrawerOpen(false);
                      // pass overrides so getData applies the pending sort immediately
                      updateUrlStoreType(appliedStore);
                      await getData(null, { storeType: appliedStore, sortState: pendingSortState });
                    }}
                  >
                    Apply
                  </IonButton>
                </div>
              </div>
            </div>
          </IonToolbar>
        </IonFooter>
      </IonModal>
    </div>
  );
}
